export enum CreateVirtualCardScreen {
  Pick = 'Pick',
  Standard = 'Standard',
  DecliningBalance = 'DecliningBalance',
  Recurring = 'Recurring',
  GuestAccess = 'GuestAccess',
  RecurringGuest = 'RecurringGuest',
  Multiple = 'Multiple',
  BillPay = 'BillPay',
  MultipleBillPay = 'MultipleBillPay',
  IssuerCycle = 'IssuerCycle',
}
